import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Rank from "./rank";
import Filters from "./filters";
import SearchBar from "./searchBar";
import axios from "axios";
import SendLog from "../services/SendLog.js";

const DivBody = styled.div`
  min-height: 90vh;
  width: 100%;
  @media (min-width: 820px) {
    display: flex;
  }
`;
const DivMain = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: white;
  color: #c0392b;
  font-size: 15px;
  text-align: center;
`;

const wait = async (time) => {
  const promise = (x, time) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(x);
      }, time);
    });
  };
  return await promise(null, time);
};

const Body = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState();
  const [currentFilter, setCurrentFilter] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    //simulando a request
    axios
      .post(
        "https://mochila.tapiocahut.com/component-rank",
        {
          category: "filters",
        }
      )
      .then((response) => {
        setFilters(response.data.filters);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    SendLog();
    axios
      .post(
        "https://mochila.tapiocahut.com/component-rank",
        { options: currentFilter }
      )
      .then(async (response) => {
        // await console.log(response);
        setData(response["data"]);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });

    wait(1000)
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentFilter]);

  const selectFilter = (filter, value) => {
    let newFilter = {};
    newFilter[filter] = value;

    setCurrentFilter(newFilter);
  };

  return (
    <DivBody>
      <DivMain>
        <Filters
          filters={filters}
          onSelectFilter={selectFilter}
          setFilters={setFilters}
        ></Filters>
        <SearchBar value={searchTerm} onChange={setSearchTerm} />
        {error ? (
          <ErrorMessage>
            Não foi possível carregar o ranking. Verifique sua conexão e tente novamente.
          </ErrorMessage>
        ) : (
          <Rank loading={loading} data={data} searchTerm={searchTerm}></Rank>
        )}
      </DivMain>
    </DivBody>
  );
};

export default Body;
